"use client";

import SearchIcon from "@/components/atoms/svg/icons/SearchIcon";
import { type InputProps } from "@/components/ui/input";
import { useAgentProvider } from "@/features/home/contexts/AgentProvider";
import { cn } from "@/lib/utils";
import { useDebounceCallback } from "usehooks-ts";

interface SearchInputProps
  extends Pick<InputProps, "className" | "defaultValue"> {
  onChange?: (value: string) => void;
}

export default function SearchInput({ className, onChange }: SearchInputProps) {
  const { search, setSearch, setIsFiltering, setPage } = useAgentProvider();
  const debounced = useDebounceCallback((search: string) => {
    // Reset page to 1 after search
    setPage?.(1);

    setIsFiltering?.(true);
    setSearch?.(search);
    onChange?.(search);
  }, 500);

  return (
    <div
      className={cn(
        "flex items-center relative w-full mx-auto max-w-[792px] -translate-y-1/2 h-16 sm:h-20",
        className,
      )}
    >
      <span className="absolute right-3 top-1/2 transform -translate-y-1/2 z-[1] rounded-full border border-action-normal bg-background text-primary shadow-xs w-10 h-10 flex items-center justify-center">
        <SearchIcon fill="#0F1324" fillOpacity="0.6" />
      </span>
      <input
        id="search-input"
        type="text"
        placeholder="Search"
        className="w-full !p-[20px_19px_20px_40px] input-focus !rounded-full h-full shadow-01 border border-white/20 bg-white/80 backdrop-blur-[18px] overflow-hidden my-agent--inputSearch focus:!outline-none focus:!border-0 focus:!ring-0 focus:!shadow-01 placeholder:!text-base-quaternary/20 text-base-quaternary/60 text-[20px] leading-caption-l font-normal placeholder:font-normal"
        defaultValue={search}
        onChange={(e) => debounced(e.target.value)}
      />
    </div>
  );
}
